/**
 * @desc createBatchLines
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.BatchCreateRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/Batch/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
